import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaPen, FaCreditCard } from "react-icons/fa";
import { RiArrowDownWideLine } from "react-icons/ri";
import { IoMdCloseCircle } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";


const PaymentPage0 = ({
  data,
  address,
  selectedDeliveryPrice,
  selectedDate,
  selectedTimeslot,
  deliveryType,
  handlingCharges,
  rainSurgeCharge,
  giftWrapFee,
  donationFee,
  tip,
}) => {
  const [isBagOpen, setIsBagOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(false);
  const [isDeliverHere, setIsDeliverHere] = useState(false);
  const navigate = useNavigate();
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const accessToken = sessionStorage.getItem("accessToken");
  const [selectedMethod, setSelectedMethod] = useState("wallet");
  const [upiSubMethod, setUpiSubMethod] = useState("qr");
  const app_logo = sessionStorage.getItem("appLogo");
  const appName = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;

  const preparePipeSeparatedFormData = () => {
    const cartItems = data?.get_admin_cart_product_lists || [];

    const added_by_id = cartItems.map((item) => item.user_auto_id).join("|");
    const added_by = cartItems.map((item) => item.added_by).join("|");
    const product_auto_id = cartItems
      .map((item) => item.product_auto_id)
      .join("|");
    const product_name = cartItems.map((item) => item.product_name).join("|");
    const quantity = cartItems.map((item) => item.cart_quantity).join("|");
    const product_price = cartItems.map((item) => item.product_price).join("|");
    const product_offer_percentage = cartItems
      .map((item) => item.product_offer_percentage)
      .join("|");
    const product_final_price = cartItems
      .map((item) => Number(item.final_product_price))
      .join("|");
    const product_image = cartItems
      .map((item) => item.product_images[0].image_file)
      .join("|");
    const size = cartItems.map((item) => item.user_seleted_size).join("|");
    const including_tax = cartItems.map((item) => item.including_tax).join("|");
    const tax_percentage = cartItems
      .map((item) => item.tax_percentage)
      .join("|");

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    formData.append("customer_auto_id", accessToken);
    formData.append("product_auto_id", product_auto_id);
    formData.append("added_by_id", added_by_id);
    formData.append("added_by", added_by);
    formData.append("product_name", product_name);
    formData.append("quantity", quantity);
    formData.append("product_price", product_price);
    formData.append("product_offer_percentage", product_offer_percentage);
    formData.append("product_final_price", product_final_price);
    formData.append("product_image", product_image);
    formData.append("size", size);
    formData.append("including_tax", including_tax);
    formData.append("tax_percentage", tax_percentage);
    formData.append(
      "user_delivery_charge",
      JSON.stringify(data?.user_delivery_charge || [])
    );
    formData.append(
      "user_total_price",
      JSON.stringify(data?.user_total_price || [])
    );
    formData.append("address", address.address_details);
    formData.append("city", address.city);
    formData.append("state", address.state);
    formData.append("country", address.country);
    formData.append("used_pincode", address.pincode);
    formData.append("mobile_no", address.mobile_no);
    formData.append("payment_mode", selectedMethod);
    formData.append("delivery_type", "Normal");
    formData.append(
      "payment_mode_type",
      selectedMethod === "wallet" ? "Prepaid" : ""
    );
    formData.append("subscription_type", "");

    if (selectedDeliveryPrice) {
      formData.append("delivery_slot_price", selectedDeliveryPrice);
    }
    if (selectedDate) {
      formData.append("schedule_date", selectedDate);
    }
    if (selectedTimeslot) {
      formData.append("delivery_time", selectedTimeslot);
    }
    if (deliveryType) {
      const formattedDeliveryType =
        deliveryType === "Normal Delivery"
          ? "Normal"
          : deliveryType === "Express Delivery"
            ? "Express"
            : deliveryType;
      formData.append("delivery_type", formattedDeliveryType);
    }
    if (handlingCharges && handlingCharges !== "" && handlingCharges !== null) {
      formData.append("handling_fee", handlingCharges);
    }
    if (donationFee && donationFee !== "" && donationFee !== null) {
      formData.append("donation_fee", donationFee);
    }
    if (giftWrapFee && giftWrapFee !== "" && giftWrapFee !== null) {
      formData.append("giftwrap_fee", giftWrapFee);
    }
    if (tip && tip !== "" && tip !== null) {
      formData.append("tip_amount", tip);
    }
    if (rainSurgeCharge && rainSurgeCharge !== "" && rainSurgeCharge !== null) {
      formData.append("rain_surge_charge", rainSurgeCharge);
    }
    // Handle cust_image for customizable items
    const cust_image = cartItems
      .map(item => item.cust_image ? item.cust_image : "")
      .join("|");

    formData.append("cust_image", cust_image);



    return formData;
  };

  const [placingOrder, setPlacingOrder] = useState(false);
  const [orderMessage, setOrderMessage] = useState("");
  const [orderStatus, setOrderStatus] = useState(null);

  const handlePlaceOrder = async () => {

    setPlacingOrder(true);
    setOrderMessage("");
    setOrderStatus(null);
    const formData = preparePipeSeparatedFormData();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/place_order`,
        formData
      );
      if (response.data.status === "1") {
        window.dispatchEvent(new Event("cart-updated"));
        setOrderMessage("Order placed successfully!");
        setOrderStatus("success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setOrderMessage("Failed to place order.");
        setOrderStatus("error");
      }
    } catch (error) {
      console.error("Order error:", error);
      setOrderMessage("Something went wrong. Please try again.");
      setOrderStatus("error");
    } finally {
      setPlacingOrder(false);
    }
  };

  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color
      );
    }
  }, []);

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const renderRightSection = () => {
    if (selectedMethod === "upi") {
      return (
        <div className="w-full">
          <p className="mb-2 text-sm text-red-600">Currently not available</p>
        </div>
      );
    }

    if (selectedMethod === "wallet") {
      return (
        <div className="w-full">
          <p className="flex flex-col gap-1 mb-2 text-gray-700">
            <span>
              {" "}
              Pay through <strong>Wallet</strong> .{" "}
            </span>
            <span className="text-sm">
              Please keep sufficient balance before placing the order. To check
              balance,{" "}
              <Link
                className="text-blue-500 cursor-pointer hover:text-blue-700 "
                to="/dashboard"
                state={{
                  page: "mywallet",
                }}
              >
                Click here
              </Link>
            </span>
          </p>

          <div className="flex justify-center mt-3">
            <button
              className={`px-4 py-2 text-white rounded w-80 transition duration-300 ${placingOrder ? "bg-gray-400 cursor-not-allowed" : ""
                }`}
              style={!placingOrder ? { backgroundColor: themeColor } : {}}
              onMouseEnter={(e) => {
                if (!placingOrder) {
                  const darkenedColor = darkenHexColor(themeColor, 0.15);
                  e.currentTarget.style.backgroundColor = darkenedColor;
                }
              }}
              onMouseLeave={(e) => {
                if (!placingOrder) {
                  e.currentTarget.style.backgroundColor = themeColor;
                }
              }}
              onClick={handlePlaceOrder}
              disabled={placingOrder}
            >
              {placingOrder ? "Placing Order..." : "Place Order"}
            </button>


          </div>
          {orderMessage && (
            <p
              className={`  flex justify-center mt-3 text-sm font-medium ${orderStatus === "success" ? "text-green-600" : "text-red-600"
                }`}
            >
              {orderMessage}
            </p>
          )}
        </div>
      );
    }

    if (selectedMethod === "COD") {
      return (
        <div className="w-full">
          <p className="mb-2 text-sm ">
            Pay with cash when your order is delivered to your doorstep. It's a
            safe and convenient way to shop without using online payments.
          </p>
          <div className="flex justify-center mt-3">
            <button
              className={`px-4 py-2 text-white rounded w-80 transition duration-300 ${placingOrder ? "bg-gray-400 cursor-not-allowed" : ""
                }`}
              style={!placingOrder ? { backgroundColor: themeColor } : {}}
              onMouseEnter={(e) => {
                if (!placingOrder) {
                  const darkenedColor = darkenHexColor(themeColor, 0.15);
                  e.currentTarget.style.backgroundColor = darkenedColor;
                }
              }}
              onMouseLeave={(e) => {
                if (!placingOrder) {
                  e.currentTarget.style.backgroundColor = themeColor;
                }
              }}
              onClick={handlePlaceOrder}
              disabled={placingOrder}
            >
              {placingOrder ? "Placing Order..." : "Place Order"}
            </button>


          </div>
          {orderMessage && (
            <p
              className={` flex justify-center mt-3  text-sm font-medium ${orderStatus === "success" ? "text-green-600" : "text-red-600"
                }`}
            >
              {orderMessage}
            </p>
          )}
        </div>
      );
    }

    return null;
  };

  const menuItems = [
    { key: "upi", label: "UPI", desc: "Google Pay, PhonePe, Paytm & more" },
    { key: "wallet", label: "Wallet", desc: "Paytm Wallet" },
    { key: "COD", label: "Cash on Delivery", desc: "Pay at your doorstep" },
  ];

  // Calculate total delivery charge
  const totalDeliveryCharge = selectedDeliveryPrice
    ? Number(data?.pincode_delivery_charge || 0) + Number(selectedDeliveryPrice)
    : Number(data?.pincode_delivery_charge || 0);

  // Calculate final total price including delivery charges and additional fees
  const totalPrice =
    data?.get_admin_cart_product_lists?.reduce(
      (acc, item) => acc + Number(item.final_product_price || 0),
      0
    ) || 0;
  const finalTotalPrice = (
    totalPrice +
    totalDeliveryCharge +
    (handlingCharges && handlingCharges !== "" && handlingCharges !== null
      ? Number(handlingCharges)
      : 0) +
    (rainSurgeCharge && rainSurgeCharge !== "" && rainSurgeCharge !== null
      ? Number(rainSurgeCharge)
      : 0) +
    (giftWrapFee && giftWrapFee !== "" && giftWrapFee !== null
      ? Number(giftWrapFee)
      : 0) +
    (donationFee && donationFee !== "" && donationFee !== null
      ? Number(donationFee)
      : 0) +
    (tip && tip !== "" && tip !== null ? Number(tip) : 0)
  ).toFixed(2);

  return (
    <div className="min-h-screen p-4 py-6 font-sans bg-white">
      <header className="flex items-center justify-center pt-2 pb-3 border-b ">
        {logoAvailable ? (
          <img src={fullLogoUrl} alt={appName} className="h-14 pl-14" />
        ) : (
          appName
        )}
        <nav className="items-center justify-center hidden w-full pt-2 pb-2 space-x-6 md:flex">
          <div className="flex items-center space-x-2">
            <FaCheckCircle className="text-black h-7 w-7" />
            <span className="text-gray-500">Sign Up</span>
          </div>
          <div className="w-72 h-0.5 bg-gray-300"></div>
          <div className="flex items-center space-x-2">
            <FaPen className="w-6 h-6 text-black" />
            <span className="font-semibold text-black">Address</span>
          </div>
          <div className="w-72 h-0.5 bg-gray-300"></div>
          <div className="flex items-center space-x-2">
            <FaCreditCard className="text-black h-7 w-7" />
            <span className="text-gray-500">Payment</span>
          </div>
        </nav>
      </header>
      <main className=" sm:mx-2 md:mt-4 md:mx-32">
        <h1 className="font-semibold ">Choose payment method</h1>
        <p className="text-gray-500 sm:mb-20">
          Choose the payment method you prefer
        </p>
        <div className="flex-col gap-6 p-0 sm:flex md:flex-row sm:p-6 md:p-8">
          <div className="flex flex-col md:flex-row border rounded overflow-hidden 
                md:h-[500px] md:w-[750px] w-full">

            {/* Left Section */}
            <div
              className="flex flex-col w-full overflow-y-auto border border-r-0 border-gray-200 divide-y md:w-2/5"
            >
              {menuItems.map((item) => (
                <div key={item.key} className="w-full">

                  {/* Header Button */}
                  <button
                    onClick={() =>
                      setSelectedMethod(selectedMethod === item.key ? null : item.key)
                    }
                    className={`
            flex w-full text-left p-2 sm:p-4 items-center gap-3 
            ${selectedMethod === item.key ? "bg-gray-50" : ""}
          `}
                  >
                    {/* Highlight Bar (Desktop Only) */}
                    <div
                      className="hidden w-1 h-full md:block"
                      style={{
                        backgroundColor:
                          selectedMethod === item.key ? themeColor : "transparent",
                      }}
                    />

                    <div className="flex-1">
                      <p className="font-semibold">{item.label}</p>
                      <p className="text-sm text-gray-500">{item.desc}</p>
                    </div>

                    {/* Mobile Dropdown Arrow */}
                    <span className="ml-2 md:hidden">
                      <svg
                        className={`transition-transform ${selectedMethod === item.key ? "rotate-180" : ""}`}
                        width="19"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M6 9l6 6 6-6"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>

                  </button>

                  {/* Mobile Dropdown Content */}
                  {selectedMethod === item.key && (
                    <div className="px-2 py-3 border-t md:hidden sm:px-4 bg-gray-50">
                      {renderRightSection()}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Right Section — Desktop Only */}
            <div className="hidden w-3/5 overflow-y-auto border border-l-0 border-gray-200 md:block sm:p-4">
              {renderRightSection()}
            </div>
          </div>


          <div className="flex flex-col w-full md:w-[500px]">
            <div className="px-2 pt-4 transition-all duration-300 border">
              <div className="pb-2 mb-2 border-b">
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => setIsBagOpen(!isBagOpen)}
                >
                  <h3 className="text-lg font-semibold">Bag</h3>
                  <div className="flex items-center">
                    {!isBagOpen && (
                      <span>
                        {data?.get_admin_cart_product_lists?.length} Items
                      </span>
                    )}
                    <RiArrowDownWideLine
                      className={`ml-2 transition-transform ${isBagOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                </div>
                {isBagOpen &&
                  data?.get_admin_cart_product_lists?.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between gap-1 mt-2 text-black"
                    >
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images?.[0]?.image_file}`}
                        alt={item.product_name}
                        className="object-cover w-10 h-10"
                      />
                      <span className="flex flex-col">
                        {item.product_name}
                        <span className="text-xs">
                          {item.user_seleted_size?.[0]?.size_name ||
                            "Free Size"}{" "}
                          | {item.color_name}
                        </span>
                      </span>
                    </div>
                  ))}
              </div>

              <div className="pb-2 ">
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => setIsDeliverHere(!isDeliverHere)}
                >
                  <span className="font-semibold">Deliver here</span>
                  <div className="flex items-center">
                    <span>
                      {address.name}, {address.pincode}
                    </span>
                    <RiArrowDownWideLine
                      className={`ml-2 transition-transform ${isDeliverHere ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                </div>
                {isDeliverHere && (
                  <div className="mt-2 ">
                    <div className="flex flex-col justify-start mt-4">
                      <span className="text-xs">
                        {address.address_details}, {address.state}
                      </span>
                      <span className="text-xs">
                        {address.city}-{address.pincode}
                      </span>
                      <span className="text-xs">{address.mobile_no}</span>
                      <br />
                    </div>
                  </div>
                )}
              </div>

              <div className="pb-2 ">
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => setIsPriceOpen(!isPriceOpen)}
                >
                  <span className="font-semibold">Price Details</span>
                  <div className="flex items-center">
                    {!isPriceOpen && <span>₹{finalTotalPrice}</span>}
                    <RiArrowDownWideLine
                      className={`ml-2 transition-transform ${isPriceOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                </div>
                {isPriceOpen && (
                  <div className="mt-2 ">
                    <div className="flex justify-between mt-4">
                      <span className="text-xs">
                        Bag MRP ({data?.get_admin_cart_product_lists?.length}{" "}
                        items)
                      </span>
                      <span className="text-xs font-semibold">
                        ₹{data?.total_price}
                      </span>
                    </div>
                    <div className="flex justify-between mt-4">
                      <span className="text-xs">Delivery Charges</span>
                      <span className="text-xs text-green-600">
                        ₹{totalDeliveryCharge || "0"}
                      </span>
                    </div>
                    {handlingCharges &&
                      handlingCharges !== "" &&
                      handlingCharges !== null && (
                        <div className="flex justify-between mt-4">
                          <span className="text-xs">Handling Charges</span>
                          <span className="text-xs font-semibold">
                            ₹{handlingCharges}
                          </span>
                        </div>
                      )}
                    {rainSurgeCharge &&
                      rainSurgeCharge !== "" &&
                      rainSurgeCharge !== null && (
                        <div className="flex justify-between mt-4">
                          <span className="text-xs">Rain Surge Charge</span>
                          <span className="text-xs font-semibold">
                            ₹{rainSurgeCharge}
                          </span>
                        </div>
                      )}
                    {giftWrapFee &&
                      giftWrapFee !== "" &&
                      giftWrapFee !== null && (
                        <div className="flex justify-between mt-4">
                          <span className="text-xs">Gift Wrap Fee</span>
                          <span className="text-xs font-semibold">
                            ₹{giftWrapFee}
                          </span>
                        </div>
                      )}
                    {donationFee &&
                      donationFee !== "" &&
                      donationFee !== null && (
                        <div className="flex justify-between mt-4">
                          <span className="text-xs">Donation</span>
                          <span className="text-xs font-semibold">
                            ₹{donationFee}
                          </span>
                        </div>
                      )}
                    {tip && tip !== "" && tip !== null && (
                      <div className="flex justify-between mt-4">
                        <span className="text-xs">Tip</span>
                        <span className="text-xs font-semibold">₹{tip}</span>
                      </div>
                    )}
                    <div className="flex justify-between mt-4">
                      <span className="text-xl font-semibold">You Pay</span>
                      <span className="text-xl font-semibold">
                        <span className="pr-1 font-normal text-black line-through">
                          ₹{data?.total_paid_price}
                        </span>
                        ₹{finalTotalPrice}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center p-3 mt-4 space-x-2 bg-gray-100">
              <p className="text-sm text-gray-500">
                Buy authentic products. Pay securely. Easy returns and exchange
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentPage0;
